import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'ic-batches',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  template: `
    <div>
      <svg
        [attr.width]="width"
        [attr.height]="height"
        viewBox="0 0 16 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        [style.opacity]="opacity"
      >
        @if(hasGradient){
        <defs>
          <linearGradient
            [attr.id]="gradientId"
            gradientUnits="userSpaceOnUse"
            x1="0"
            y1="0"
            x2="16"
            y2="20"
          >
            <stop offset="0%" [style.stop-color]="startColor" />
            <stop offset="100%" [style.stop-color]="endColor" />
          </linearGradient>
        </defs>
        }

        <path
          d="M7.36328 4.40039C7.64198 4.40039 7.90846 4.51621 8.09766 4.7207C8.09812 4.73281 8.17376 6.67376 9 7.5C9.82883 8.32883 11.7344 8.64941 11.7344 8.64941C11.9054 8.83429 12 9.07729 12 9.3291V18.5996C12 19.3728 11.3728 20 10.5996 20H1.40039C0.627191 20 0 19.3728 0 18.5996V5.7998C5.28261e-05 5.02665 0.627223 4.40039 1.40039 4.40039H7.36328ZM11.3633 0C11.6419 0 11.9085 0.115917 12.0977 0.320312L15.7344 4.25C15.9052 4.43473 16 4.67712 16 4.92871V14.2002C15.9999 14.9733 15.3727 15.5996 14.5996 15.5996C14.0475 15.5994 13.5996 15.1518 13.5996 14.5996C13.5997 14.2726 13.7572 13.7998 14 13.7998V5.92871H11.7637C10.9906 5.92871 10.3635 5.30231 10.3633 4.5293V2H5.98047C5.88781 2.45645 5.48379 2.7998 5 2.7998C4.44772 2.7998 4 2.35208 4 1.7998V1.40039C4 0.627191 4.62719 0 5.40039 0H11.3633Z"
          [attr.fill]="
            hasGradient ? 'url(#' + gradientId + ')' : color || defaultColor
          "
        />
      </svg>
    </div>
  `,
})
export class IcBatchesComponent {
  @Input() startColor: string | null = null;
  @Input() endColor: string | null = null;
  @Input() opacity = 1;
  @Input() width: number | string = 16;
  @Input() height: number | string = 20;
  @Input() color = '';
  defaultColor = '#B8C0C6';
  gradientId = `batchesGradient-${Math.random().toString(36).slice(2)}`;

  get hasGradient(): boolean {
    return !!this.startColor?.trim() && !!this.endColor?.trim();
  }
}
